export const icons = {
  add: (
    <svg
      className="uk-margin-small-right"
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
    >
      <path
        d="M17.375 7.875H10.625V1.125C10.625 0.826631 10.5065 0.540484 10.2955 0.329505C10.0845 0.118527 9.79837 0 9.5 0C9.20163 0 8.91548 0.118527 8.7045 0.329505C8.49353 0.540484 8.375 0.826631 8.375 1.125V7.875H1.625C1.32663 7.875 1.04048 7.99353 0.829505 8.2045C0.618527 8.41548 0.5 8.70163 0.5 9C0.5 9.29837 0.618527 9.58452 0.829505 9.7955C1.04048 10.0065 1.32663 10.125 1.625 10.125H8.375V16.875C8.375 17.1734 8.49353 17.4595 8.7045 17.6705C8.91548 17.8815 9.20163 18 9.5 18C9.79837 18 10.0845 17.8815 10.2955 17.6705C10.5065 17.4595 10.625 17.1734 10.625 16.875V10.125H17.375C17.6734 10.125 17.9595 10.0065 18.1705 9.7955C18.3815 9.58452 18.5 9.29837 18.5 9C18.5 8.70163 18.3815 8.41548 18.1705 8.2045C17.9595 7.99353 17.6734 7.875 17.375 7.875Z"
        fill="var(--primary-color)"
      />
    </svg>
  ),
  productdelete: (
    <svg
      className="uk-margin-small-right"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
    >
      <path
        d="M2 16.0045C2 17.1022 2.89991 18 4.00002 18H12C13.1001 18 14 17.1022 14 16.0045V4.5H2V16.0045ZM15.5 1.5H11.75L10.4945 0H5.50559L4.25 1.5H0.5V3H15.5V1.5Z"
        fill="var(--primary-color)"
      />
    </svg>
  ),
  addnew: (
    <svg
      className="uk-margin-small-right"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M1.8 3.6H0V16.2C0 17.1945 0.8055 18 1.8 18H14.4V16.2H1.8V3.6ZM16.2 0H5.4C4.4055 0 3.6 0.8055 3.6 1.8V12.6C3.6 13.5945 4.4055 14.4 5.4 14.4H16.2C17.1945 14.4 18 13.5945 18 12.6V1.8C18 0.8055 17.1945 0 16.2 0ZM15.3 8.1H11.7V11.7H9.9V8.1H6.3V6.3H9.9V2.7H11.7V6.3H15.3V8.1Z"
        fill="var(--primary-color)"
      />
    </svg>
  ),
  warning: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0ZM8 3.42857C7.8549 3.42845 7.71138 3.45859 7.57858 3.51706C7.44579 3.57554 7.32666 3.66107 7.22879 3.76819C7.13092 3.87531 7.05646 4.00167 7.01018 4.13918C6.9639 4.2767 6.94681 4.42236 6.96 4.56686L7.37714 9.14514C7.39332 9.29907 7.46591 9.44155 7.58093 9.54511C7.69594 9.64868 7.84523 9.70599 8 9.70599C8.15477 9.70599 8.30406 9.64868 8.41908 9.54511C8.53409 9.44155 8.60668 9.29907 8.62286 9.14514L9.03886 4.56686C9.05204 4.42246 9.03498 4.27689 8.98877 4.13945C8.94256 4.00201 8.8682 3.87572 8.77046 3.76861C8.67271 3.66151 8.55371 3.57596 8.42106 3.51741C8.2884 3.45886 8.145 3.42861 8 3.42857ZM8 12.5714C8.24248 12.5714 8.47504 12.4751 8.6465 12.3036C8.81796 12.1322 8.91429 11.8996 8.91429 11.6571C8.91429 11.4147 8.81796 11.1821 8.6465 11.0106C8.47504 10.8392 8.24248 10.7429 8 10.7429C7.75752 10.7429 7.52496 10.8392 7.3535 11.0106C7.18204 11.1821 7.08571 11.4147 7.08571 11.6571C7.08571 11.8996 7.18204 12.1322 7.3535 12.3036C7.52496 12.4751 7.75752 12.5714 8 12.5714Z"
        fill="var(--primary-color)"
      />
    </svg>
  ),
};
